import { getFastlyUrl } from '@corratech/pylot-image'

export const makeOptimizedUrl = (s: string, options?: any) => {
    if (!s) return s

    // If it is a Magento media directive, we need to resolve it
    if (s.includes('{{') || s.includes('url=')) {
        return getFastlyUrl({
            src: s,
            width: options?.width,
            quality: options?.quality || 85
        })
    }

    // If it's already an absolute URL or a simple relative path,
    // we can still use getFastlyUrl for optimization if desired.
    // However, to match master's behavior for non-directives,
    // we could just return s.
    // BUT, master's Row and Column components expect a valid URL for backgroundImage.

    return getFastlyUrl({
        src: s,
        width: options?.width,
        quality: options?.quality || 85
    })
}
